export default __webpack_public_path__ + "images/farm-factory_faf310.png";